import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { normalizeError } from './error.normalizer';
import { ErrorPresenter } from './error.presenter';
import { SUPPRESS_ERROR_TOAST } from './error.http-context';

export const errorInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const presenter = inject(ErrorPresenter);
    const suppress = req.context.get(SUPPRESS_ERROR_TOAST); // default: false

    return next(req).pipe(
        catchError((err: unknown) => {
            const normalized = normalizeError(err);

            if (!suppress) {
                // Snackbar immer; bei schweren Fehlern zusätzlich Dialog (Logik im Presenter)
                presenter.present(normalized);
            }

            // Fehler weiterreichen (damit Call-Sites weiterhin reagieren könnten)
            return throwError(() => normalized);
        })
    );
};
